import React from 'react';
import PropTypes from 'prop-types';
import { View, Text, ActivityIndicator } from 'react-native';
import ReactRouterPropTypes from 'react-router-prop-types';
import { matchPath } from 'react-router-dom';
import { signOut } from '@aws-amplify/auth';
// import AORTypes from '../../types';
import { translate } from '../../locales/i18n';
import styles from '../../styles';

class Logout extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'Logout';
  }

  componentDidMount() {
    const { userIdentity } = this.props;

    console.log('componentDidMount');

    if (userIdentity) {
      this.doLogout();
    }
  }

  componentDidUpdate(prevProps) {
    const { userIdentity } = this.props;
    const { userIdentity: prevUserIdentity } = prevProps;

    console.log('componentDidUpdate');

    if (userIdentity && userIdentity !== prevUserIdentity) {
      this.doLogout();
    }
  }

  getRedirect() {
    const { location } = this.props;
    const match = matchPath('/logout/*', location.pathname);
    return match ? `/${match.params['*']}` : '/';
  }

  doLogout() {
    const {
      history,
      getAnalyticsService,
    } = this.props;
    const redirect = this.getRedirect();

    console.log('doLogout');
    console.log(redirect);

    getAnalyticsService().report.event('logout', 'user');

    signOut({
      globalSignOut: true,
      global: true,
    })
      .then(() => {
        history.push((redirect && redirect !== '') ? redirect : '/');
      })
      .catch((err) => {
        console.error(err);
      });
  }

  render() {
    return (
      <View
        style={styles.view.headless}
      >
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            style={{
              marginVertical: 10,
            }}
          >
            {translate('auth_logout')}
          </Text>
          <ActivityIndicator size="large" color={styles.primaryColor} />
        </View>
      </View>
    );
  }
}

Logout.defaultProps = {
  userIdentity: undefined,
};

Logout.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  userIdentity: PropTypes.string,
};

export default Logout;
